import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from '../../axiosConfig';

function ClubLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post("/myclub/login/", {
        username,
        password,
      });

      // Save tokens in localStorage
      localStorage.setItem("access_token", response.data.access);
      localStorage.setItem("refresh_token", response.data.refresh);

      // Store user profile with is_club flag for navbar display
      localStorage.setItem("user_profile", JSON.stringify({
        is_club: true,
        club_id: response.data.club_id,
      }));

      // Check if there's a pending invitation to accept
      const pendingInvitationToken = localStorage.getItem('pending_invitation_token');
      const redirect = searchParams.get('redirect');

      if (redirect === 'accept-invitation' && pendingInvitationToken) {
        localStorage.removeItem('pending_invitation_token');
        navigate(`/club-admin/accept-invite/${pendingInvitationToken}`);
        return;
      }

      // Redirect to the dashboard
      navigate(`/myclub/dashboard/`);
    } catch (error) {
      setError(error.response?.data?.error || "Login failed. Please try again.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="cl-login-form">
      <input
        className="cl-login-input"
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
      />
      <input
        className="cl-login-input"
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <button type="submit" className="cl-login-btn">Login</button>
      {error && <p className="cl-login-error">{error}</p>}
    </form>
  );
}

export default ClubLogin;
